if(!customElements.get('featured-collection-tabs')) {
  class FeaturedCollectionTabs extends HTMLElement {
    constructor() {
      super();
    }
    
    bindEvents() {
      const _this = this;
      const tabs = this.querySelectorAll('.featured-collection-tabs li');
      const tabContents = this.querySelectorAll('.featured-collection-tab__content-wrapper');

      // set aria-selected=true to first tab
      tabs.length > 0 && tabs[0].setAttribute('aria-selected', true);
      
      // bind click events to tabs
      tabs.forEach((tab) => {
        tab.addEventListener('click', function(e) {
          tabs.forEach((tab) => { tab.setAttribute('aria-selected', false)});
          tabContents.forEach((tabContent) => { tabContent.style.display = 'none'});
          const selectedTabId = e.target.getAttribute('aria-controls');

          e.target.setAttribute('aria-selected', true);
          
          if(_this.querySelector(`#${selectedTabId}`)) {
            _this.querySelector(`#${selectedTabId}`).style.display = "block";
          }
        });
      });
    }

    connectedCallback() {
      this.bindEvents();
    }
  }
  
  customElements.define('featured-collection-tabs', FeaturedCollectionTabs);
}